import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = [
    "data-fixed",
    "data-sticky"
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _openBlock(), _createElementBlock("div", {
        class: "pe-frame-footer",
        "data-fixed": _ctx.fixedStyle,
        "data-sticky": _ctx.stickyStyle
    }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 8, _hoisted_1);
}
